import { render } from "./TextAreaEditor.vue?vue&type=template&id=3fa57f76&scoped=true"
import script from "./TextAreaEditor.vue?vue&type=script&lang=js"
export * from "./TextAreaEditor.vue?vue&type=script&lang=js"

import "./TextAreaEditor.vue?vue&type=style&index=0&id=3fa57f76&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa57f76"]])

export default __exports__